interface RecordingIndicatorProps {
  active: boolean
}

export function RecordingIndicator({ active }: RecordingIndicatorProps) {
  if (!active) return null
  return (
    <span
      role="status"
      className="inline-flex items-center gap-2 rounded-pill border border-border-default px-3 py-1 font-mono text-text-primary text-xs uppercase tracking-wide"
    >
      <span className="dot-pulse h-2 w-2 rounded-pill bg-accent" aria-hidden />
      Идёт запись
    </span>
  )
}
